<template>
	<div class="layout-inner dashbaord">
		<navbar></navbar>
		<div class="layout-container">
			<div class="layout-content">
				<div v-if="!isDataLoaded" class="w-100 h-100 d-flex justify-content-center align-items-center">
          <spinner size="large"></spinner>
        </div>
				<div class="container-fluid flex-grow-1 pg_content_container" v-if="isDataLoaded">
					<div class="col-12">
						<div class="row">
							<div class="col-12 pg_sec_head">
								<div class="hd_txt">{{ $t('welcome', { name: userName }) }}</div>
				      </div>
						</div>
						<div class="row" v-if="isFinancialInformationEnabled() && (userObject.userProfile && userObject.userProfile.dueDate)">
							<div class="col-9" :class="(userObject.userProfile.overDue) ? 'alert_msg_sec' : 'alert_msg_sec_yellow'" style="margin: auto; margin-bottom: 15px;">
								<div class="row">
									<div class="col-9 msg_container">
										<span v-if="userObject.userProfile.overDue">
										{{ $t('paymentOverdueSince', { dueDate: userObject.userProfile.dueDate }) }}
										</span>
										<span v-else>
										{{ $t('nextPaymentDueBy', { dueDate: userObject.userProfile.dueDate }) }}
										</span>
									</div>
									<div class="col-3 btn_container" >
										<b-btn @click="launchPaymentLink">{{ $t('pay') }}</b-btn>
									</div>
								</div>
							</div>
						</div>

						<template v-for="componentRow in learnerDashboardComponents">
							<component-row :program-guide="programGuide" :component-row="componentRow"></component-row>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import _ from 'lodash'
	import { mapState, mapActions } from 'vuex'
	import Navbar from '../../misc/components/./Navbar'
	import { PACKAGE } from '../../../package_constants'
	import ComponentRow from './ComponentRow'

	export default {
		name: 'learner-dashboard',
		components: {
			Navbar,
      ComponentRow
    },
		data: () => {
			return {
				programGuide: '',
				isDataLoaded: false
			}
		},
		async beforeMount () {
			await this.loadUserObj()
			await this.populateDashboardData()
    },
    mounted () {
    	if (!_.isEmpty(this.$route.query)) {
    		this.$router.replace({'query': null})
    	}
    	this.$root.$on('reloadLearnerDashboard', () => {
	      this.populateDashboardData()
	    })
    },
    computed: {
    	...mapState({
    		'userObject': state => state.login.userObj,
    		'enabledFeatures': state => state.dashboard.enabledFeatures,
    		'institution': state => state.dashboard.institution,
	      'learnerDashboardComponents': state => state.dashboard.learnerDashboardComponents
	    }),
			userName () {
        return this.userObject.firstName
      },
      isExplorePackageEnabled () {
	      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_FEATURE_ID]
	      if (exploreFeature) {
	        return exploreFeature.enabled
	      }
	      return false
	    }
		},
		methods: {
			...mapActions([
				'loadUserObj',
				'loadLearnerDashboardState',
        'loadLearnerEnrollmentData',
	      'loadLearnerEnrolledProgram'
	    ]),
	    async populateDashboardData () {
	    	let userObj = this.userObject
        await this.loadLearnerDashboardState()
        await this.loadLearnerEnrollmentData()
	    	if (userObj && userObj.major1) {
          this.programGuide = await this.loadLearnerEnrolledProgram()
          setTimeout(() => {
            this.isDataLoaded = true
          }, 0)
        } else {
          this.isDataLoaded = true
        }
	    },
	    isFinancialInformationEnabled () {
          return this.isFlagEnabled('learner_dashboard', 'Show Financial Information')
      },
      launchPaymentLink(){
        window.open(this.institution.invoicePaymentLink, '_blank')
      },
      isFlagEnabled (featureId, flagValue) {
        let learnerDB = this.enabledFeatures[featureId]
        if (learnerDB && learnerDB.enabled) {
          let flags = learnerDB.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === flagValue) {
              return flags[i].enabled
            }
          }
        }
        return false;
      }
	  }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerDashboard.vue